export type ActionPlanApiTarget = 'legacy' | 'microservice';

export type ActionPlanApiRequestOptions = {
  actionPlanApiTarget?: ActionPlanApiTarget;
};

type ResolveActionPlanApiBaseURLInput = ActionPlanApiRequestOptions & {
  actionPlanV2Api: boolean;
  actionPlanV2Origin: string;
  actionPlanV2ScreenActive: boolean;
  isDevelopment: boolean;
  url: string | undefined;
};

/** Origin MS.ActionPlan (không có `/api`) — dev gọi thẳng khi set NEXT_PUBLIC_AP_V2_*. */
export const resolveActionPlanV2ApiOrigin = (): string => {
  const raw =
    process.env.NEXT_PUBLIC_AP_V2_API_ORIGIN?.trim() ||
    process.env.NEXT_PUBLIC_AP_V2_API_BASE_URL?.trim() ||
    process.env.CONFIG_NEXT_PUBLIC_AP_V2_API_BASE_URL?.trim() ||
    '';
  if (raw) {
    return raw.replace(/\/$/, '').replace(/\/api$/i, '');
  }
  return '';
};

/** Route FE Action Plan v2 — không ảnh hưởng /du-an, /cong-viec-du-an legacy. */
export const isActionPlanV2ScreenActive = (): boolean => {
  if (typeof window === 'undefined') return false;
  const p = window.location.pathname.replace(/\/$/, '') || '/';
  return (
    p === '/action-plan-v2' ||
    p.startsWith('/action-plan-v2/') ||
    p === '/action-plan' ||
    p.startsWith('/action-plan/')
  );
};

/**
 * API path thuộc MS.ActionPlan microservice.
 * `setupactionplan`: cột / rule Kanban (V2 dùng `DuAnKanBans.MauSac` — monolith không có field này sẽ ghi đè null).
 */
export const isActionPlanMicroserviceApiPath = (url: string | undefined): boolean => {
  if (!url) return false;
  const path = url.startsWith('http') ? new URL(url, 'http://local').pathname : url;
  return /^\/v1\/(actionplanv2|duan|congviec|ghichu|baocaocongviec|setupactionplan)\b/i.test(path);
};

export const resolveActionPlanApiBaseURL = ({
  actionPlanApiTarget,
  actionPlanV2Api,
  actionPlanV2Origin,
  actionPlanV2ScreenActive,
  isDevelopment,
  url,
}: ResolveActionPlanApiBaseURLInput): string | undefined => {
  if (!actionPlanV2Origin || !isActionPlanMicroserviceApiPath(url)) {
    return undefined;
  }
  if (actionPlanApiTarget === 'microservice') {
    return `${actionPlanV2Origin}/api`;
  }
  if (actionPlanApiTarget === 'legacy') {
    return undefined;
  }
  return isDevelopment && (actionPlanV2Api || actionPlanV2ScreenActive)
    ? `${actionPlanV2Origin}/api`
    : undefined;
};

/** @deprecated alias — dùng isActionPlanMicroserviceApiPath */
export const isActionPlanV2ApiPath = isActionPlanMicroserviceApiPath;
